import { useWallet } from '../contexts/WalletContext'

const backdropStyle: React.CSSProperties = {
  position: 'fixed',
  inset: 0,
  background: 'rgba(0,0,0,0.5)',
  zIndex: 200,
}

const modalStyle: React.CSSProperties = {
  position: 'fixed',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  zIndex: 201,
  background: '#fff',
  borderRadius: 16,
  width: 360,
  maxWidth: 'calc(100vw - 32px)',
  boxShadow: '0 20px 60px rgba(0,0,0,0.2)',
  overflow: 'hidden',
}

const modalHeaderStyle: React.CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: '20px 24px 16px',
  borderBottom: '1px solid #f3f4f6',
}

const closeBtnStyle: React.CSSProperties = {
  background: 'none',
  border: 'none',
  fontSize: 18,
  cursor: 'pointer',
  color: '#9ca3af',
  lineHeight: 1,
  padding: 4,
}

const bodyStyle: React.CSSProperties = {
  padding: '24px 24px 28px',
  display: 'flex',
  flexDirection: 'column',
  gap: 12,
}

const primaryBtnStyle: React.CSSProperties = {
  display: 'block',
  width: '100%',
  padding: '12px 0',
  background: '#6366f1',
  color: '#fff',
  border: 'none',
  borderRadius: 10,
  fontWeight: 600,
  fontSize: 15,
  cursor: 'pointer',
  textDecoration: 'none',
  textAlign: 'center',
}

const warnBtnStyle: React.CSSProperties = {
  ...primaryBtnStyle,
  background: '#ef4444',
}

const networkBadgeStyle: React.CSSProperties = {
  padding: '6px 12px',
  background: '#fef3c7',
  border: '1px solid #fbbf24',
  borderRadius: 8,
  fontSize: 13,
  color: '#92400e',
  textAlign: 'center',
}

const errorStyle: React.CSSProperties = {
  fontSize: 13,
  color: '#ef4444',
  textAlign: 'center',
  padding: '6px 0',
}

export default function ConnectWalletModal() {
  const {
    isModalOpen,
    closeConnectModal,
    connect,
    switchToSepolia,
    isConnected,
    isCorrectNetwork,
    isConnecting,
    isMetaMaskInstalled,
    error,
  } = useWallet()

  if (!isModalOpen) return null

  return (
    <>
      <div style={backdropStyle} onClick={closeConnectModal} aria-hidden="true" />

      <div style={modalStyle} role="dialog" aria-modal="true" aria-labelledby="modal-title">
        <div style={modalHeaderStyle}>
          <h2 id="modal-title" style={{ margin: 0, fontSize: 17, fontWeight: 700 }}>
            지갑 연결
          </h2>
          <button style={closeBtnStyle} onClick={closeConnectModal} aria-label="닫기">
            ✕
          </button>
        </div>

        <div style={bodyStyle}>
          <div style={{ fontSize: 52, textAlign: 'center', lineHeight: 1 }}>🦊</div>

          {!isMetaMaskInstalled ? (
            <>
              <p style={{ textAlign: 'center', color: '#6b7280', margin: 0, lineHeight: 1.6 }}>
                MetaMask를 설치해 주세요
              </p>
              <a
                href="https://metamask.io/download/"
                target="_blank"
                rel="noopener noreferrer"
                style={primaryBtnStyle}
              >
                MetaMask 설치하기
              </a>
            </>
          ) : (
            <>
              <p style={{ textAlign: 'center', color: '#6b7280', margin: 0, lineHeight: 1.6 }}>
                지갑을 연결하여 챌린지에
                <br />
                참가하거나 개설할 수 있습니다.
              </p>
              <div style={networkBadgeStyle}>필요 네트워크: Ethereum Sepolia</div>

              {!isConnected ? (
                <button
                  style={primaryBtnStyle}
                  onClick={() => void connect()}
                  disabled={isConnecting}
                >
                  {isConnecting ? '연결 중...' : 'MetaMask 연결'}
                </button>
              ) : !isCorrectNetwork ? (
                <>
                  <p style={{ textAlign: 'center', color: '#ef4444', margin: 0, fontSize: 13 }}>
                    네트워크 불일치 — Sepolia로 전환해 주세요
                  </p>
                  <button style={warnBtnStyle} onClick={() => void switchToSepolia()}>
                    Sepolia로 전환
                  </button>
                </>
              ) : null}
            </>
          )}

          {error && <p style={errorStyle}>{error}</p>}
        </div>
      </div>
    </>
  )
}
